export const FEATURE_SEPARATOR = "--";
